<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("posicionGlobal")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div v-if="filterText==='T'" class="col-md-3">
                            <div class="form-group">
                                <label>{{$t('negocios')}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="c in listBusinesses"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.establishmentName"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div v-else class="col-md-3">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <!--
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>{{$t("fecha")}}</label>
                                                        <el-date-picker
                                                                v-model="value4"
                                                                type="daterange"
                                                                format="dd-MM-yyyy"
                                                                start-placeholder="Fecha incio"
                                                                end-placeholder="Fecha fin">
                                                        </el-date-picker>
                                                    </div>
                                                </div>-->


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <el-button type="primary" :loading="loading" :disabled="loading" @click="getGlobal()">
                                    {{$t("consultar")}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else>
                <div class="col-md-8">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-6">
                                <el-button-group>
                                    <el-button @click="getDataCompany()" type="primary" size="medium"
                                            :disabled="loading"
                                            :class="{'active-filter': filterText == 'E'}"><i class="fas fa-building"></i> {{$t('todasLasEmpresas')}}
                                    </el-button>
                                    <el-button @click="getGlobal()" type="primary" size="medium"
                                            :disabled="loading"
                                            :class="{'active-filter': filterText == 'N'}"><i class="fas fa-briefcase"></i>
                                        {{$t('negocios')}}
                                    </el-button>
                                    <el-button @click="getDataTpv()" type="primary" size="medium"
                                            :disabled="loading"
                                            :class="{'active-filter': filterText == 'T'}"><i class="fas fa-desktop"></i> {{$t('TPV')}}
                                    </el-button>
                                </el-button-group>
                            </div>
                            <div class="col-md-3 text-right">
                                <el-checkbox v-model="trabajarSinIva">
                                    {{ $t("mostrarSinIva") }}
                                    <i
                                        v-tooltip.top-center="
                                            'Si esta opción está activada, mostrará los datos descontándole el IVA'
                                        "
                                        class="fa fa-info-circle"
                                    >
                                    </i>
                                </el-checkbox>
                            </div>
                            <div class="col-md-3 text-right" v-if="dateInform.length > 0">
                                <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu  slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown></div>
                        </div>


                        <template v-if="!searchPerformed">
                            <div class="alert alert-info" role="alert"  style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
                                <i class="fa fa-info-circle" ></i> {{ $t("clickConsultarParaRealizarBusqueda") }}...
                            </div>
                        </template>
                        <template v-else-if="loading">
                            <div class="alert alert-warning mb-0">
                                <i class="fa fa-spinner fa-spin"></i>
                                {{ $t("cargandoDatos") }}...
                            </div>
                        </template>
                        <template v-else-if="dateInform.length>0">
                            <div class="table-responsive" style="overflow: auto">
                                <table class="table table-bordered table-striped ">

                                    <thead class="thead-dark">
                                    <tr>
                                        <th v-if="ordenacionEmpresa === 0" @click="sortedArrayEmpresaASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("empresa")}}
                                        </th>
                                        <th v-else @click="sortedArrayEmpresaDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("empresa")}}
                                        </th>
                                        <th v-if="ordenacionVentas === 0" @click="sortedArrayVentasASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("ventas")}}
                                        </th>
                                        <th v-else @click="sortedArrayVentasDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("ventas")}}
                                        </th>
                                        <th v-if="ordenacionGastos === 0" @click="sortedArrayGastosASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("gastos")}}
                                        </th>
                                        <th v-else @click="sortedArrayGastosDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("gastos")}}
                                        </th>
                                        <th v-if="ordenacionNeto === 0" @click="sortedArrayNetoASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("neto")}}
                                        </th>
                                        <th v-else @click="sortedArrayNetoDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("neto")}}
                                        </th>
                                        <th v-if="tipo == 1 && ordenacionCambio === 0" @click="sortedArrayCambioASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("cambioSigDia")}}
                                        </th>
                                        <th v-else-if="tipo == 1" @click="sortedArrayCambioDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("cambioSigDia")}}
                                        </th>
                                        <th v-if="tipo == 2 && ordenacionPorcentaje === 0" @click="sortedArrayPorcentajeASC()">
                                            <i style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("porcentaje")}}
                                        </th>
                                        <th v-else-if="tipo == 2" @click="sortedArrayPorcentajeDESC()">
                                            <i style="color: white" class="fa fa-angle-down"></i>
                                            {{$t("porcentaje")}}
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="obj in dateInform">
                                        <td>{{obj.nameBusines }}</td>
                                        <td align="right" v-if="!trabajarSinIva">{{obj.sales | currency}}</td>
                                        <td align="right" v-else>{{obj.salesSinIva | currency}}</td>
                                        <td align="right" v-if="!trabajarSinIva">{{obj.expenses | currency}}</td>
                                        <td align="right" v-else>{{obj.expensesSinIva | currency}}</td>
                                        <td align="right" v-if="!trabajarSinIva">{{obj.sales - obj.expenses | currency}}</td>
                                        <td align="right" v-else>{{obj.salesSinIva - obj.expensesSinIva | currency}}</td>
                                        <td v-if="tipo == 1" align="right">{{obj.cashChange | currency}}</td>
                                        <td v-if="tipo == 2" align="right">{{getPorcentaje((obj.sales - obj.expenses))}}</td>
                                    </tr>
                                    </tbody>

                                    <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{$t("total")}}:</strong></td>
                                        <td align="right"><strong>{{getTotalVentas | currency}}</strong></td>
                                        <td align="right"><strong>{{getTotalGastos | currency}}</strong></td>
                                        <td align="right"><strong>{{getTotalNeto | currency}}</strong></td>
                                        <td v-if="tipo == 1"></td>
                                        <td v-if="tipo == 2"></td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>

                        </template>
                        <template v-else>

                            <div class="alert alert-danger" role="alert">
                                {{$t("noHayFacturasEmitidasEnEsteRangoDeFecha")}}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="col-md-4 ">
                    <div class="card">
                        <div class="charts-container col-md-12 " style="height:40vh;">
                            <canvas id="charts"></canvas>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        
        <!-- Modal de mantenimiento para getDataCompany -->
        <MaintenanceModal
            :title="$t('funcionEnMantenimiento')"
            :message="$t('getDataCompanyMantenimiento')"
            :buttonText="$t('entendido')"
        />
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import MaintenanceModal from "@/components/Modal/MaintenanceModal.vue";
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, ButtonGroup, Checkbox, CheckboxGroup,} from 'element-ui'
    import swal from 'sweetalert2'
    import { mapState } from "vuex";
    import moment from 'moment'
    import Chart from 'chart.js';

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Posicion Global");
            this.getCompanies();
            this.getBusiness();
            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.value4[0] = this.$store.getters.dateFrom;
                this.value4[1] = this.$store.getters.dateTo;

            }
        },
        components: {
            MaintenanceModal,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [ButtonGroup.name]: ButtonGroup,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        data() {
            return {
                loading: false,
                searchPerformed: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listBusinesses: [],
                idBusiness: 0,
                data: [''],
                listTpv: [],
                cuentasAparcadas: false,
                dateInform: [],
                indice: 0,
                filterText:'E',

                //CHARTS
                objectChart: null,
                contador: 0,

                tipo:0,

                idCompany: 0,
                listCompany: [],
                total: 0,

                ordenacionEmpresa: 0,
                ordenacionVentas: 0,
                ordenacionGastos: 0,
                ordenacionNeto: 0,
                ordenacionPorcentaje: 0,
                ordenacionCambio: 0,

                trabajarSinIva: false,
            }
        },
        computed: {
            ...mapState(["sectores", "listaSectores", "permiso"]),

            sortedArrayEmpresaASC: function () {
                this.ordenacionEmpresa = 1;

                function compare(a, b) {
                    if (a.nameBusines.toUpperCase() < b.nameBusines.toUpperCase()) return -1;
                    if (a.nameBusines.toUpperCase() > b.nameBusines.toUpperCase()) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayEmpresaDESC: function () {
                this.ordenacionEmpresa = 0;

                function compare(a, b) {
                    if (a.nameBusines.toUpperCase() > b.nameBusines.toUpperCase()) return -1;
                    if (a.nameBusines.toUpperCase() < b.nameBusines.toUpperCase()) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayVentasASC: function () {
                this.ordenacionVentas = 1;

                function compare(a, b) {
                    if (a.sales < b.sales) return -1;
                    if (a.sales > b.sales) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayVentasDESC: function () {
                this.ordenacionVentas = 0;

                function compare(a, b) {
                    if (a.sales > b.sales) return -1;
                    if (a.sales < b.sales) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayGastosASC: function () {
                this.ordenacionGastos = 1;

                function compare(a, b) {
                    if (a.expenses < b.expenses) return -1;
                    if (a.expenses > b.expenses) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayGastosDESC: function () {
                this.ordenacionGastos = 0;

                function compare(a, b) {
                    if (a.expenses > b.expenses) return -1;
                    if (a.expenses < b.expenses) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayNetoASC: function () {
                this.ordenacionNeto = 1;

                function compare(a, b) {
                    if ((a.sales - a.expenses) < (b.sales - b.expenses)) return -1;
                    if ((a.sales - a.expenses) > (b.sales - b.expenses)) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayNetoDESC: function () {
                this.ordenacionNeto = 0;

                function compare(a, b) {
                    if ((a.sales - a.expenses) > (b.sales - b.expenses)) return -1;
                    if ((a.sales - a.expenses) < (b.sales - b.expenses)) return 1;
                    return 0;
                }

                return this.dateInform.sort(compare);
            },

            sortedArrayPorcentajeASC: function () {
                if(this.total != 0) {
                    let vm = this;
                    this.ordenacionPorcentaje = 1;

                    function compare(a, b) {
                        if (((a.sales - a.expenses) / vm.total * 100) < ((b.sales - b.expenses) / vm.total * 100)) return -1;
                        if (((a.sales - a.expenses) / vm.total * 100) > ((b.sales - b.expenses) / vm.total * 100)) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compare);
                } else {
                    return "";
                }
            },

            sortedArrayPorcentajeDESC: function () {
                if(this.total != 0) {
                    let vm = this;
                    this.ordenacionPorcentaje = 0;

                    function compare(a, b) {
                        if (((a.sales - a.expenses) / vm.total * 100) > ((b.sales - b.expenses) / vm.total * 100)) return -1;
                        if (((a.sales - a.expenses) / vm.total * 100) < ((b.sales - b.expenses) / vm.total * 100)) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compare);
                } else {
                    return "";
                }
            },

            sortedArrayCambioASC: function () {
                if(this.total != 0) {
                    let vm = this;
                    this.ordenacionCambio = 1;

                    function compare(a, b) {
                        if (a.cashChange < b.cashChange) return -1;
                        if (a.cashChange > b.cashChange) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compare);
                } else {
                    return "";
                }
            },

            sortedArrayCambioDESC: function () {
                if(this.total != 0) {
                    let vm = this;
                    this.ordenacionCambio = 0;

                    function compare(a, b) {
                        if (a.cashChange > b.cashChange) return -1;
                        if (a.cashChange < b.cashChange) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compare);
                } else {
                    return "";
                }
            },

            urlExportPDF() {
                return this.$store.getters.apiUrl+"/sales/exportPosicionGlobal/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + this.idTpv + "&idCompany=" + this.idCompany + "&tipo=" + this.tipo + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            urlExportExcel() {
                return this.$store.getters.apiUrl+"/sales/exportPosicionGlobal/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + this.idTpv + "&idCompany=" + this.idCompany  + "&tipo=" + this.tipo + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalGastos() {
                let total = 0;
                let vm = this;

                this.dateInform.forEach(function (d) {
                   
                    if(vm.trabajarSinIva) {
                        total += d.expensesSinIva;
                    } else {
                        total += d.expenses;
                    }

                });

                return total;
            },

            getTotalVentas() {
                this.total = 0;
                let total = 0;
                let vm = this;

                this.dateInform.forEach(function (d) {

                    if(vm.trabajarSinIva) {
                        total += d.salesSinIva;
                    } else {
                        total += d.sales;
                    }
                    
                });

                this.total = total;
                return total;
            },

               getTotalNeto() {
                this.total = 0;
                let total = 0;
                let vm = this;

                this.dateInform.forEach(function (d) {

                    if(vm.trabajarSinIva) {
                        total += d.salesSinIva;
                        total -= d.expensesSinIva;
                    } else {
                        total += d.sales;
                        total -= d.expenses;
                    }
                    
                });

                this.total = total;
                return total;
            }
        },
        methods: {

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getCompanies() {


                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        // vm.getGlobal();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getGlobalSectores() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        datefrom: moment(this.datefrom).startOf("day").unix(),
                        dateto: moment(this.dateto).endOf("day").unix(),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "sales/getGlobalSectores", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.dateInform = response.data.result;

                            vm.initChart();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                        vm.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getGlobal() {

                this.tipo=1;

                this.filterText='E';

                if (this.listCompany.length === 0) {
                    return;
                }

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        this.searchPerformed = true;
                        this.loading = true;

                        if (this.sectores && this.$cookies.isKey("sectores")) {
                            this.getGlobalSectores();
                            return;
                        }

                        var config = {
                            params: {
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/getGlobal", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.dateInform = response.data.result;

                                    vm.initChart();
                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                }
                                vm.loading = false;
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
            getIdUser() {
                const token = this.$store.state.xjwt;
                if (!token) {
                    console.error("No se encontró el token JWT.");
                    return null;
                }

                try {
                    const base64Url = token.split('.')[1];
                    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    const jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                    );
                    const decodedJWT = JSON.parse(jsonPayload);
                    return decodedJWT.idUser || null;
                } catch (error) {
                    console.error("Error al decodificar el token JWT:", error);
                    return null;
                }
            },
            getDataCompany() {
                
                // Mostrar modal de mantenimiento y cortar ejecución
                
                // let idUser = this.getIdUser();
                // if (idUser != 9461){
                //     this.$modal.show('maintenanceModal');
                //     return;
                // }
                
                // (TEMPORAL) No permitir continuar si en listCompany hay mas de 15 companies
                if (this.listCompany.length > 15) {
                    this.$modal.show('maintenanceModal');
                    return;
                }
                
                // CÓDIGO ORIGINAL CONSERVADO PARA FUTURO USO
                this.tipo=2;

                this.filterText='E';

                if (this.listCompany.length === 0) {
                    return;
                }

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        this.searchPerformed = true;
                        this.loading = true;

                        var config = {
                            params: {
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/getDataCompany", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.dateInform = response.data.result;

                                    vm.initChart();
                                } else {

                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                }
                                vm.loading = false;
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
            getDataTpv() {

                this.tipo=3;

                this.filterText='T';

                if (this.listBusinesses.length === 0) {
                    return;
                }

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        this.searchPerformed = true;
                        this.loading = true;

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/getDataTpv", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.dateInform = response.data.result;

                                    vm.initChart();
                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
            initChart() {
                const vm = this;

                var labels = ["GASTOS", "VENTAS", "NETO"]

                var data = [this.getTotalGastos, this.getTotalVentas, this.getTotalNeto]

                let backgroundColor = [
                    'rgba(217, 83, 79)',
                    'rgba(92, 184, 92)',
                    'rgba(0, 0, 240)'
                ];  

                let hoverBackground = [
                    'rgba(217, 83, 79)',
                    'rgba(92, 184, 92)',
                    'rgba(0, 0, 240)'
                ];

                if (this.contador === 0) {
                    if (this.dateInform.length > 0) {

                        this.objectChart = new Chart("charts", {
                            type: 'bar',
                            data: {
                                labels: labels,
                                datasets: [{
                                label: vm.$t('balance'),
                                data: data,
                                backgroundColor: backgroundColor,
                                hoverBackgroundColor: hoverBackground,
                                borderWidth: 1
                            }]
                            },
                            options: {
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true
                                        }
                                    }]
                                },
                                legend: {
                                    display: true,
                                    position: 'bottom'
                                },
                                beginAtZero: true,
                                responsive: true,
                                maintainAspectRatio: false
                            }
                        });

                        this.contador++;
                    }
                } else {
                    this.objectChart.destroy();

                    this.objectChart = new Chart("charts", {
                        type: 'bar',
                        data: {
                            labels: labels,
                            datasets: [{
                                label: vm.$t('balance'),
                                data: data,
                                backgroundColor: backgroundColor,
                                hoverBackgroundColor: hoverBackground,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                            },
                            legend: {
                                display: true,
                                position: 'bottom'
                            },
                            responsive: true,
                            maintainAspectRatio: false
                        }
                    });
                }
            },
            getPorcentaje(importe) {
                if(this.total != 0) {
                    return (importe/ this.total * 100).toFixed(2) + "  %";
                }
                return "";
                // return "0";
                // return "0.00 %";
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/PosicionGlobal/PosicionGlobal.vue